import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

const FactCheckModal = () => {
  const [openFactCheckModal, setFactCheckModal] = useState(false);
  const closeButtonRef = useRef(null);
  const { i18n, t } = useTranslation();
  useEffect(() => {
    document.body.style.overflow = openFactCheckModal ? 'hidden' : '';
  }, [openFactCheckModal]);

  const setFocusToCloseButton = event => {
    if (!_.isEmpty(event.relatedTarget)) {
      let relatedClassName = event.relatedTarget.className;
      if (relatedClassName.includes('dialogComponent')) return;
      else closeButtonRef.current.focus();
    }
  };
  return (
    <>
      <div
        className="factCheck themeFocus"
        onClick={() => setFactCheckModal(true)}
        onKeyDown={e => {
          if (e.key === 'Enter') setFactCheckModal(true);
        }}
        tabIndex={0}
      >
        <span>{t('Fact Checked')}</span>
      </div>
      {openFactCheckModal && (
        <div
          className="mainModal mainFactCheckModal"
          onBlur={setFocusToCloseButton}
        >
          <div
            className="transparentBg"
            onClick={() => setFactCheckModal(false)}
          ></div>
          <div className="factCheckModal">
            <div className="subHeader">
              <span>{t('modal_header')}</span>
              <span
                className="closeModals whiteFocus"
                onClick={() => setFactCheckModal(false)}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    setFactCheckModal(false);
                  }
                }}
                ref={closeButtonRef}
                tabIndex={0}
              >
                <img
                  src="/content/images/icons/icon-close-white.svg"
                  width="20px"
                  height="20px"
                  alt=""
                  aria-hidden="true"
                />
              </span>
            </div>
            <div className="subContent">
              <p>{t('Para1_text')}</p>
              <p>
                {t('All content on')} &nbsp;
                <a
                  className="dialogComponent"
                  href={_.withLocale(i18n.language, '/')}
                >
                  singlecare.com
                </a>
                &nbsp; {t('Para2_text')}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FactCheckModal;
